@if ((incomeTaxEntity$ | async) && isOndernemer) {
  <form [formGroup]="formGroup">
    <div>
      @if (nietAftrekbareKosten.length > 0) {
        <div formArrayName="nietAftrekbareKosten">
          @for (item of nietAftrekbareKosten.controls; track item; let i = $index) {
            <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving kosten' : ''"
                                              [required]="true"
                                              class="custom-input-250"
                                              formControlName="omschrijving"
                                              id="omschrijvingNietAftrek"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Niet aftrekbaar' : ''"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="bedrag"
                                                id="bedragNietAftrek"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-button (click)="deleteNietAftrekbareKosten(i)"
                                   [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                   icon="trash"
                                   iconType="light"
                                   id="buttonDeleteNiet"
                                   size="medium"
                                   type="secondary"
              >
              </snelstart-ui-button>
            </div>
          }
        </div>
      }
      <snelstart-ui-button (click)="addRijNietAftrekbareKosten()" class="snelstart-ui-button pb-3" icon="plus"
                           type="link">
        Niet aftrekbare kosten toevoegen
      </snelstart-ui-button>
    </div>

    <div>
      @if (beperktAftrekbareKosten.length > 0) {
        <div formArrayName="beperktAftrekbareKosten">
          @for (item of beperktAftrekbareKosten.controls; track item; let i = $index) {
            <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving kosten' : ''"
                                              [required]="true"
                                              class="custom-input-250"
                                              formControlName="omschrijving"
                                              id="omschrijvingNietAftrek"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Niet aftrekbaar deel ' : ''"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="bedrag"
                                                id="bedragNietAftrek"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-button (click)="deleteBeperktAftrekbareKosten(i)"
                                   [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                   icon="trash"
                                   iconType="light"
                                   id="buttonDeleteNiet"
                                   size="medium"
                                   type="secondary"
              >
              </snelstart-ui-button>
            </div>
          }
        </div>
      }
      <snelstart-ui-button (click)="addRijBeperktAftrekbareKosten()" class="snelstart-ui-button pb-3" icon="plus"
                           type="link">
        Beperkt aftrekbare kosten toevoegen
      </snelstart-ui-button>
    </div>

    <div>
      @if (vrijgesteldeWinst.length > 0) {
        <div formArrayName="vrijgesteldeWinst">
          @for (item of vrijgesteldeWinst.controls; track item; let i = $index) {
            <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving vrijgestelde winst' : ''"
                                              [required]="true"
                                              class="custom-input-250"
                                              formControlName="omschrijving"
                                              id="omschrijvingNietAftrek"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Vrijgesteld bedrag' : ''"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="bedrag"
                                                id="bedragNietAftrek"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-button (click)="deleteVrijgesteldeWinst(i)"
                                   [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                   icon="trash"
                                   iconType="light"
                                   id="buttonDeleteNiet"
                                   size="medium"
                                   type="secondary"
              >
              </snelstart-ui-button>
            </div>
          }
        </div>
      }
      <snelstart-ui-button (click)="addVrijgesteldeWinst()" class="snelstart-ui-button" icon="plus"
                           type="link">
        Vrijgestelde winstbestanddelen toevoegen
      </snelstart-ui-button>
    </div>
  </form>
} @else {
  <p>Er zijn geen ondernemingen gevonden.</p>
}
